import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Static tags remain in raw HTML for non-JS crawlers; Helmet owns them after mount.
document.querySelectorAll('head title, head meta[name="description"], head meta[name="robots"], head meta[property^="og:"], head meta[name^="twitter:"], head link[rel="canonical"], head link[hreflang]').forEach((tag) => tag.remove());
const root = document.getElementById("root");
if (root) createRoot(root).render(<App />);
